import { Footer } from "@/components/LandingPage/Footer";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import Navbar from "@/components/LandingPage/Navbar";
import womanSvg from "@root/public/images/photos/woman.png";
import { Link } from "@chakra-ui/next-js";
import {
  Box,
  Button,
  Container,
  Divider,
  Heading,
  HStack,
  Stack,
  Text,
  Flex,
  Grid,
  Center,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Head from "next/head";
import Image from "next/image";
import heroBg from "@root/public/images/photos/clarifayo_community.jpg";
import { useViewport } from "@/hooks/useViewport";

import type { Metadata } from "next";
import { TestimonialsSection } from "@/components/LandingPage/TestimonialsSection";
import { NestIcon } from "@/components/LandingPage/NestIcon";
import { BirdNestIcon } from "@/components/LandingPage/BirdNestIcon";
import { BulletPoint } from "@/components/LandingPage/BulletPoint";

export const metadata: Metadata = {
  title: "Clarifayo",
  description: "Unlock your potential with the ultimate coaching experience!",
};

const Hero = () => {
  const t = useTranslations("CoachCommunity");
  const { isMobile } = useViewport();

  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      py={{ base: 8, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      bgColor="brand.1000"
      h="100vh"
      position="relative"
      overflow={"hidden"}
      backgroundImage={`url(${heroBg.src})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundAttachment="fixed"
    >
      <Box className="hero-bg"></Box>
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>

      <Stack
        direction={["column", "row"]}
        gap={16}
        mt={{ base: 16, md: "200px" }}
        alignItems={"flex-start"}
        w="full"
        zIndex={1}
      >
        <Box flex={1} maxW={{ base: "full", md: "50vw" }} textAlign="left">
          <Heading
            fontWeight={600}
            fontSize={{ base: "42px", md: "68px" }}
            textAlign={{ base: "center", md: "left" }}
            mb={4}
            color="white"
            lineHeight={"1"}
            fontFamily={`'Marlide', sans-serif`}
          >
            <Text
              dangerouslySetInnerHTML={{
                __html: t.raw("communityClarifayo"),
              }}
            ></Text>
          </Heading>
          <Text
            fontSize={{ base: "18px", md: "22px" }}
            color="white"
            textAlign={{ base: "center", md: "left" }}
            mb={8}
            dangerouslySetInnerHTML={{
              __html: t.raw("buildCommunity"),
            }}
          ></Text>
        </Box>
      </Stack>

      <Container maxW="container.xl" mt={8}></Container>
    </Stack>
  );
};

const UnderConstruction = () => {
  const t = useTranslations();
  return (
    <Container
      maxW="container.xl"
      py={{ base: 8, md: 24 }}
      px={{ base: 8, md: 24 }}
    >
      <Heading mb={8}>{t("willBeAble")}</Heading>
      <Grid
        mb={16}
        w="full"
        gridTemplateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(2, 1fr)",
        }}
        gap={16}
      >
        <Stack
          direction={"column"}
          gap={{
            base: 8,
            md: 10,
          }}
          mb={16}
        >
          <BulletPoint>{t("willBeAble1")}</BulletPoint>
          <BulletPoint>{t("willBeAble2")}</BulletPoint>
          <BulletPoint>{t("willBeAble3")}</BulletPoint>
          <BulletPoint>{t("willBeAble4")}</BulletPoint>
          <BulletPoint>{t("willBeAble5")}</BulletPoint>
        </Stack>
        <Center w="full">
          <Image quality={80} src={womanSvg} alt="Woman" />
        </Center>
      </Grid>
      <Flex direction="column" align="center" justify="center">
        <Stack gap={8} mb={100} align="center">
          <Divider borderColor="black.900" orientation="vertical" h={24} />
          <BirdNestIcon width={80} height={80} />
          <Link
            prefetch={false}
            href="/pricing"
            w={{
              base: "full",
              md: "auto",
            }}
            mt={8}
          >
            <Button
              py={4}
              fontSize={{ base: "22px", md: "28px" }}
              fontFamily={`'Marlide', sans-serif`}
              variant="primary"
              fontWeight={900}
              p={10}
              letterSpacing=".1rem"
              w={{
                base: "full",
                md: "auto",
              }}
            >
              Let&apos;s Clarifayo
            </Button>
          </Link>
        </Stack>
      </Flex>
    </Container>
  );
};

export default function Page() {
  return (
    <>
      <Head>
        <title>Clarifayo - maximize your Coaching Activity</title>
      </Head>
      <Box className="landing-page">
        <Hero />
        <UnderConstruction />
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}
